export class ReportOperations {
    public static downloadFile(url: string, name: string): void {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
